import { render, staticRenderFns } from "./BridgeOverview.vue?vue&type=template&id=4252cd56&scoped=true&"
import script from "./BridgeOverview.vue?vue&type=script&lang=js&"
export * from "./BridgeOverview.vue?vue&type=script&lang=js&"
import style0 from "./BridgeOverview.vue?vue&type=style&index=0&id=4252cd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252cd56",
  null
  
)

export default component.exports